import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'

import { PATHS } from 'Config/Routing/paths'
import { CitiesWrapper } from 'Components/City'
import { CityPageContext } from 'Components/City/Page/Context'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import { CityHeaderNav } from 'Containers/City/Page/HeaderNav'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import CitiesIcon from 'Assets/Images/icons/cities'
import WarningLabel from '../../../Components/WarningLabel/WarningLabel'
import WeatherWidget from '../../../Components/WeatherWidget'
import { getCityCoords } from '../../../Module/graphQL'
import { getMetricSystemByCityId } from '../../../Components/WeatherWidget/util'
import StyledBreadcrumbs from '../../../Components/StyledBreadcrumbs'

const CityPage = props => {
  const {
    cityId,
    cityName,
    newcomersMissionsLimit,
    recruitmentOnHold,
    className,
    breadcrumbs = [],
  } = props
  const [cityCoords, setCityCoords] = useState({})
  useEffect(() => {
    const init = async () => {
      const response = await getCityCoords(cityId)
      setCityCoords(response.data.city.location)
    }
    init()
  }, [cityId])

  return (
    <CitiesWrapper className={className}>
      <WarningLabel
        visible={newcomersMissionsLimit}
        message={`
        First week blocker feature enabled! Capped at ${newcomersMissionsLimit} missions!`}
      />
      <WarningLabel
        visible={recruitmentOnHold}
        message={'Recruitment is on pause'}
      />
      <LayoutDashboard>
        <StyledBreadcrumbs
          icon={<CitiesIcon style={{ width: 24 }} />}
          breadcrumbs={[
            {
              label: 'Cities',
              link: PATHS.main.dashboard + PATHS.dashboard.cities,
            },
            {
              label: cityName,
            },
            ...breadcrumbs,
          ]}
        />

        <PageTitle>{cityName}</PageTitle>
        <WeatherWidget
          lat={cityCoords.latitude}
          lng={cityCoords.longitude}
          metric={getMetricSystemByCityId(props.cityId)}
        />
      </LayoutDashboard>
      <CityPageContext>
        <CityHeaderNav
          active={props.active}
          cityId={props.cityId}
          history={props.history}
          match={props.match}
        />
        <HideWhenBlocked>{props.children}</HideWhenBlocked>
      </CityPageContext>
    </CitiesWrapper>
  )
}

export default withRouter(CityPage)
